import DeleteGdDlysjgLocateHistoryModal from './delete-gd-dlysjg-locate-history-modal.vue'
export default DeleteGdDlysjgLocateHistoryModal
